import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PricingCard = ({ 
  plan, 
  isPopular = false, 
  onSelectPlan 
}) => {
  const {
    name,
    price,
    period,
    description,
    features,
    limitations,
    cta,
    variant = 'default'
  } = plan;

  return (
    <div className={`relative bg-card rounded-xl border-2 p-8 shadow-elevation-1 hover-lift ${
      isPopular 
        ? 'border-accent shadow-elevation-2' 
        : 'border-border hover:border-accent/50'
    }`}>
      {/* Popular Badge */}
      {isPopular && (
        <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
          <div className="bg-accent text-accent-foreground px-4 py-2 rounded-full text-sm font-semibold">
            Most Popular
          </div>
        </div>
      )}
      {/* Plan Header */}
      <div className="text-center mb-8">
        <h3 className="text-2xl font-bold text-foreground mb-2">
          {name}
        </h3>
        <p className="text-muted-foreground mb-6">
          {description}
        </p>
        
        {/* Pricing */}
        <div className="mb-6">
          {price === 0 ? (
            <div className="text-4xl font-bold text-foreground">
              Free
            </div>
          ) : (
            <div className="flex items-baseline justify-center">
              <span className="text-4xl font-bold text-foreground">
                ${price?.toLocaleString()}
              </span>
              <span className="text-muted-foreground ml-2">
                /{period}
              </span>
            </div>
          )}
        </div>

        {/* CTA Button */}
        <Button
          variant={variant === 'enterprise' ? 'outline' : 'default'}
          fullWidth
          onClick={() => onSelectPlan(plan)}
          className="mb-8"
        >
          {cta}
        </Button>
      </div>
      {/* Features List */}
      <div className="space-y-4">
        <h4 className="font-semibold text-foreground mb-4">
          What's included:
        </h4>
        
        {features?.map((feature, index) => (
          <div key={index} className="flex items-start space-x-3">
            <Icon 
              name="Check" 
              size={20} 
              className="text-success flex-shrink-0 mt-0.5"
            />
            <span className="text-sm text-foreground">
              {feature}
            </span>
          </div>
        ))}

        {/* Limitations */}
        {limitations && limitations?.length > 0 && (
          <div className="pt-4 border-t border-border">
            {limitations?.map((limitation, index) => (
              <div key={index} className="flex items-start space-x-3 mb-2">
                <Icon 
                  name="X" 
                  size={20} 
                  className="text-muted-foreground flex-shrink-0 mt-0.5"
                />
                <span className="text-sm text-muted-foreground">
                  {limitation}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default PricingCard;